// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
// THIS BREAKS THE AUTH. The redirect is derived synchronously from
// window.location.origin and Emergent returns ?session_id=... in the URL hash.
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "@/lib/AuthContext";
import { toast } from "@/components/ui/sonner";

const API = process.env.REACT_APP_BACKEND_URL
  ? `${process.env.REACT_APP_BACKEND_URL}/api`
  : "/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) {
      navigate("/auth", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await axios.post(
          `${API}/auth/google-session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        setUser(data);
        toast.success(`Signed in as ${data.email}`);
        // Clean the hash and land on Dashboard
        window.history.replaceState({}, "", "/");
        navigate("/", { replace: true });
      } catch (e) {
        toast.error(e.response?.data?.detail || "Google sign-in failed");
        navigate("/auth", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-black flex items-center justify-center" data-testid="auth-callback">
      <div className="text-[#FF0000] font-mono text-xs tracking-widest animate-pulse">
        EXCHANGING SESSION...
      </div>
    </div>
  );
}
